module.exports = __webpack_public_path__ + "static/media/brackets alt.7c22ffd3.png";